import { PlatformApi } from "@jti/rest-api";
import type { PhoneVerificationResponseType, PhoneVerificationType } from "@jti/rest-api-types";

import type { PlatformApiBuilder } from "../platformApi.types";

type ValidatePhonePayload = {
  phone: string;
  validationType?: PhoneVerificationType;
};

export const validatePhoneEndpoint = (builder: PlatformApiBuilder) => ({
  validatePhone: builder.mutation<PhoneVerificationResponseType, ValidatePhonePayload>({
    queryFn: async ({ phone, validationType }) => {
      const platformApi = PlatformApi.init();
      const response = await platformApi.verifyPhone(phone, validationType);
      return { data: response };
    },
  }),
});
